import "./style.scss";
import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        Copyright © Benent. All Rights Reserved.
      </footer>
    </>
  );
};

export default Footer;
